import Backoffice from "@snark/backoffice"

// noinspection JSUnusedLocalSymbols
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
	function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	return new (P || (P = Promise))(function (resolve, reject) {
		function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
		function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
		function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
		step((generator = generator.apply(thisArg, _arguments || [])).next());
	});
};

const context = {
};

export default {
	name: "tournament",
	collection: "tournament",
	idProperty: "_id",
	section: "data",
	pagination: 50,
	backTextFilterList: true,
	labels: {"singleTitle":"Tournament","listTitle":"Tournaments"},
	emptyItem: {},
	fields: [
		{
			name: "_id",
			label: "Id",
			readOnly: true,
			hideOnCreate: true,
		},
		{
			name: "hudlId",
			label: "Hudl Id",
		},
		{
			name: "name",
			label: "Name",
		},
		{
			name: "countryCode",
			label: "Country Code",
		},
		{
			name: "countryName",
			label: "Country Name",
		},
		{
			name: "tiersType",
			label: "Tiers Type",
			formatter: Backoffice.formatters.mapping({"professional": "Professional", "university": "University", "youth": "Youth"}),
			editor: {type: "select", options: [{value: "professional", label: "Professional"}, {value: "university", label: "University"}, {value: "youth", label: "Youth"}]},
		},
		{
			name: "tiersCategory",
			label: "Tiers Category",
			formatter: Backoffice.formatters.mapping({"s": "S", "a": "A", "b": "B", "c": "C", "d": "D", "e": "E", "college1": "College1", "college2": "College2", "college3": "College3", "college4": "College4", "youth1": "Youth1", "youth2": "Youth2", "youth3": "Youth3"}),
			editor: {type: "select", options: [{value: "s", label: "S"}, {value: "a", label: "A"}, {value: "b", label: "B"}, {value: "c", label: "C"}, {value: "d", label: "D"}, {value: "e", label: "E"}, {value: "college1", label: "College1"}, {value: "college2", label: "College2"}, {value: "college3", label: "College3"}, {value: "college4", label: "College4"}, {value: "youth1", label: "Youth1"}, {value: "youth2", label: "Youth2"}, {value: "youth3", label: "Youth3"}]},
		},
		{
			name: "competitionType",
			label: "Competition Type",
			formatter: Backoffice.formatters.mapping({"league": "League", "cup": "Cup", "tournament": "Tournament", "exhibition": "Exhibition"}),
			editor: {type: "select", options: [{value: "league", label: "League"}, {value: "cup", label: "Cup"}, {value: "tournament", label: "Tournament"}, {value: "exhibition", label: "Exhibition"}]},
		},
		{
			name: "scope",
			label: "Scope",
			formatter: Backoffice.formatters.mapping({"global": "Global", "international": "International", "continental": "Continental", "national": "National", "regional": "Regional"}),
			editor: {type: "select", options: [{value: "global", label: "Global"}, {value: "international", label: "International"}, {value: "continental", label: "Continental"}, {value: "national", label: "National"}, {value: "regional", label: "Regional"}]},
		},
		{
			name: "ageCateogry",
			label: "Age Cateogry",
			formatter: Backoffice.formatters.mapping({"senior": "Senior", "u23": "U23", "u22": "U22", "u21": "U21", "u20": "U20", "u19": "U19", "u18": "U18", "u17": "U17", "u16": "U16", "u15": "U15", "u14": "U14", "u13": "U13", "u12": "U12", "u11": "U11", "u10": "U10", "youth": "Youth"}),
			editor: {type: "select", options: [{value: "senior", label: "Senior"}, {value: "u23", label: "U23"}, {value: "u22", label: "U22"}, {value: "u21", label: "U21"}, {value: "u20", label: "U20"}, {value: "u19", label: "U19"}, {value: "u18", label: "U18"}, {value: "u17", label: "U17"}, {value: "u16", label: "U16"}, {value: "u15", label: "U15"}, {value: "u14", label: "U14"}, {value: "u13", label: "U13"}, {value: "u12", label: "U12"}, {value: "u11", label: "U11"}, {value: "u10", label: "U10"}, {value: "youth", label: "Youth"}]},
		},
		{
			name: "genderCategory",
			label: "Gender Category",
			formatter: Backoffice.formatters.mapping({"male": "Male", "female": "Female", "mixed": "Mixed"}),
			editor: {type: "select", options: [{value: "male", label: "Male"}, {value: "female", label: "Female"}, {value: "mixed", label: "Mixed"}]},
		},
		{
			name: "createdAt",
			label: "Created At",
			readOnly: true,
			hideOnCreate: true,
			formatter: Backoffice.formatters.date("DD/MM/YYYY"),
		},
		{
			name: "updatedAt",
			label: "Updated At",
			readOnly: true,
			hideOnCreate: true,
			formatter: Backoffice.formatters.date("DD/MM/YYYY"),
		},
	],
	listColumns: [
		{
			name: "hudlId",
			label: "Hudl Id",
		},
		{
			name: "name",
			label: "Name",
		},
		{
			name: "countryName",
			label: "Country Name",
		},
		{
			name: "tiersType",
			label: "Tiers Type",
			formatter: Backoffice.formatters.mapping({"professional": "Professional", "university": "University", "youth": "Youth"}),
		},
		{
			name: "tiersCategory",
			label: "Tiers Category",
			formatter: Backoffice.formatters.mapping({"s": "S", "a": "A", "b": "B", "c": "C", "d": "D", "e": "E", "college1": "College1", "college2": "College2", "college3": "College3", "college4": "College4", "youth1": "Youth1", "youth2": "Youth2", "youth3": "Youth3"}),
		},
		{
			name: "competitionType",
			label: "Competition Type",
			formatter: Backoffice.formatters.mapping({"league": "League", "cup": "Cup", "tournament": "Tournament", "exhibition": "Exhibition"}),
		},
		{
			name: "scope",
			label: "Scope",
			formatter: Backoffice.formatters.mapping({"global": "Global", "international": "International", "continental": "Continental", "national": "National", "regional": "Regional"}),
		},
		{
			name: "ageCateogry",
			label: "Age Cateogry",
			formatter: Backoffice.formatters.mapping({"senior": "Senior", "u23": "U23", "u22": "U22", "u21": "U21", "u20": "U20", "u19": "U19", "u18": "U18", "u17": "U17", "u16": "U16", "u15": "U15", "u14": "U14", "u13": "U13", "u12": "U12", "u11": "U11", "u10": "U10", "youth": "Youth"}),
		},
		{
			name: "genderCategory",
			label: "Gender Category",
			formatter: Backoffice.formatters.mapping({"male": "Male", "female": "Female", "mixed": "Mixed"}),
		},
	],
	loadSingle() {
		return Promise.all([
		]);
	},
};